var map = {
	"./Eraser_off.svg": "./src/assets/roomType/lms/img/Eraser_off.svg",
	"./Eraser_on.svg": "./src/assets/roomType/lms/img/Eraser_on.svg",
	"./arrow-down_white.svg": "./src/assets/roomType/lms/img/arrow-down_white.svg",
	"./audio_object_bg.svg": "./src/assets/roomType/lms/img/audio_object_bg.svg",
	"./btn-debate_share.svg": "./src/assets/roomType/lms/img/btn-debate_share.svg",
	"./btn_Sharing.svg": "./src/assets/roomType/lms/img/btn_Sharing.svg",
	"./btn_close.svg": "./src/assets/roomType/lms/img/btn_close.svg",
	"./btn_send.svg": "./src/assets/roomType/lms/img/btn_send.svg",
	"./camera_error.svg": "./src/assets/roomType/lms/img/camera_error.svg",
	"./camera_none.svg": "./src/assets/roomType/lms/img/camera_none.svg",
	"./camera_off.svg": "./src/assets/roomType/lms/img/camera_off.svg",
	"./camera_on.svg": "./src/assets/roomType/lms/img/camera_on.svg",
	"./close_off.svg": "./src/assets/roomType/lms/img/close_off.svg",
	"./close_on.svg": "./src/assets/roomType/lms/img/close_on.svg",
	"./color_off.svg": "./src/assets/roomType/lms/img/color_off.svg",
	"./color_on.svg": "./src/assets/roomType/lms/img/color_on.svg",
	"./delete_red.svg": "./src/assets/roomType/lms/img/delete_red.svg",
	"./device-mic-mini_off.svg": "./src/assets/roomType/lms/img/device-mic-mini_off.svg",
	"./device-mic-mini_on.svg": "./src/assets/roomType/lms/img/device-mic-mini_on.svg",
	"./device-sound_test.svg": "./src/assets/roomType/lms/img/device-sound_test.svg",
	"./device-volume_off.svg": "./src/assets/roomType/lms/img/device-volume_off.svg",
	"./device-volume_on.svg": "./src/assets/roomType/lms/img/device-volume_on.svg",
	"./draw_none.svg": "./src/assets/roomType/lms/img/draw_none.svg",
	"./draw_on.svg": "./src/assets/roomType/lms/img/draw_on.svg",
	"./enter_white.svg": "./src/assets/roomType/lms/img/enter_white.svg",
	"./eraser_clear_white.svg": "./src/assets/roomType/lms/img/eraser_clear_white.svg",
	"./google_docs.svg": "./src/assets/roomType/lms/img/google_docs.svg",
	"./gt-Volume_off.svg": "./src/assets/roomType/lms/img/gt-Volume_off.svg",
	"./gt-Volume_on.svg": "./src/assets/roomType/lms/img/gt-Volume_on.svg",
	"./hand_white.svg": "./src/assets/roomType/lms/img/hand_white.svg",
	"./ico_pause_white.svg": "./src/assets/roomType/lms/img/ico_pause_white.svg",
	"./ico_play_white.svg": "./src/assets/roomType/lms/img/ico_play_white.svg",
	"./ico_repeat_01_white.svg": "./src/assets/roomType/lms/img/ico_repeat_01_white.svg",
	"./ico_repeat_white.svg": "./src/assets/roomType/lms/img/ico_repeat_white.svg",
	"./ico_voiceRequest.svg": "./src/assets/roomType/lms/img/ico_voiceRequest.svg",
	"./ico_voiceRequest_white.svg": "./src/assets/roomType/lms/img/ico_voiceRequest_white.svg",
	"./icon-bar-graph_off.svg": "./src/assets/roomType/lms/img/icon-bar-graph_off.svg",
	"./icon-bar-graph_on.svg": "./src/assets/roomType/lms/img/icon-bar-graph_on.svg",
	"./icon-circle-graph_off.svg": "./src/assets/roomType/lms/img/icon-circle-graph_off.svg",
	"./icon-circle-graph_on.svg": "./src/assets/roomType/lms/img/icon-circle-graph_on.svg",
	"./icon-schedule-call_gray.svg": "./src/assets/roomType/lms/img/icon-schedule-call_gray.svg",
	"./icon-schedule-call_green.svg": "./src/assets/roomType/lms/img/icon-schedule-call_green.svg",
	"./icon-schedule-call_white.svg": "./src/assets/roomType/lms/img/icon-schedule-call_white.svg",
	"./icon-schedule-debate_gray.svg": "./src/assets/roomType/lms/img/icon-schedule-debate_gray.svg",
	"./icon-schedule-debate_green.svg": "./src/assets/roomType/lms/img/icon-schedule-debate_green.svg",
	"./icon-schedule-debate_white.svg": "./src/assets/roomType/lms/img/icon-schedule-debate_white.svg",
	"./icon-schedule-doc_gray.svg": "./src/assets/roomType/lms/img/icon-schedule-doc_gray.svg",
	"./icon-schedule-doc_green.svg": "./src/assets/roomType/lms/img/icon-schedule-doc_green.svg",
	"./icon-schedule-doc_white.svg": "./src/assets/roomType/lms/img/icon-schedule-doc_white.svg",
	"./icon-schedule-group_gray.svg": "./src/assets/roomType/lms/img/icon-schedule-group_gray.svg",
	"./icon-schedule-group_green.svg": "./src/assets/roomType/lms/img/icon-schedule-group_green.svg",
	"./icon-schedule-group_white.svg": "./src/assets/roomType/lms/img/icon-schedule-group_white.svg",
	"./icon-schedule-quiz_gray.svg": "./src/assets/roomType/lms/img/icon-schedule-quiz_gray.svg",
	"./icon-schedule-quiz_green.svg": "./src/assets/roomType/lms/img/icon-schedule-quiz_green.svg",
	"./icon-schedule-quiz_white.svg": "./src/assets/roomType/lms/img/icon-schedule-quiz_white.svg",
	"./icon-schedule-screenShare_gray.svg": "./src/assets/roomType/lms/img/icon-schedule-screenShare_gray.svg",
	"./icon-schedule-screenShare_green.svg": "./src/assets/roomType/lms/img/icon-schedule-screenShare_green.svg",
	"./icon-schedule-screenShare_white.svg": "./src/assets/roomType/lms/img/icon-schedule-screenShare_white.svg",
	"./icon/ico_arrowDown.svg": "./src/assets/roomType/lms/img/icon/ico_arrowDown.svg",
	"./icon/ico_arrowDown_white.svg": "./src/assets/roomType/lms/img/icon/ico_arrowDown_white.svg",
	"./icon/ico_arrowLeft.svg": "./src/assets/roomType/lms/img/icon/ico_arrowLeft.svg",
	"./icon/ico_arrowLeft_white.svg": "./src/assets/roomType/lms/img/icon/ico_arrowLeft_white.svg",
	"./icon/ico_arrowLineThickLeft.svg": "./src/assets/roomType/lms/img/icon/ico_arrowLineThickLeft.svg",
	"./icon/ico_arrowLineThickLeft_white.svg": "./src/assets/roomType/lms/img/icon/ico_arrowLineThickLeft_white.svg",
	"./icon/ico_arrowLineThickRight.svg": "./src/assets/roomType/lms/img/icon/ico_arrowLineThickRight.svg",
	"./icon/ico_arrowLineThickRight_white.svg": "./src/assets/roomType/lms/img/icon/ico_arrowLineThickRight_white.svg",
	"./icon/ico_arrowRight.svg": "./src/assets/roomType/lms/img/icon/ico_arrowRight.svg",
	"./icon/ico_arrowRight_white.svg": "./src/assets/roomType/lms/img/icon/ico_arrowRight_white.svg",
	"./icon/ico_arrowUp.svg": "./src/assets/roomType/lms/img/icon/ico_arrowUp.svg",
	"./icon/ico_arrowUp_white.svg": "./src/assets/roomType/lms/img/icon/ico_arrowUp_white.svg",
	"./icon/ico_check_black.svg": "./src/assets/roomType/lms/img/icon/ico_check_black.svg",
	"./icon/ico_check_color.svg": "./src/assets/roomType/lms/img/icon/ico_check_color.svg",
	"./icon/ico_check_white.svg": "./src/assets/roomType/lms/img/icon/ico_check_white.svg",
	"./icon/ico_dots_horiz.svg": "./src/assets/roomType/lms/img/icon/ico_dots_horiz.svg",
	"./icon/ico_dots_horiz_white.svg": "./src/assets/roomType/lms/img/icon/ico_dots_horiz_white.svg",
	"./icon/ico_heart_red.svg": "./src/assets/roomType/lms/img/icon/ico_heart_red.svg",
	"./icon/ico_logout.svg": "./src/assets/roomType/lms/img/icon/ico_logout.svg",
	"./icon/ico_logout_white.svg": "./src/assets/roomType/lms/img/icon/ico_logout_white.svg",
	"./icon/ico_menu_hidden_arrow_white.svg": "./src/assets/roomType/lms/img/icon/ico_menu_hidden_arrow_white.svg",
	"./icon/ico_menu_show_arrow.svg": "./src/assets/roomType/lms/img/icon/ico_menu_show_arrow.svg",
	"./icon/ico_menu_show_arrow_white.svg": "./src/assets/roomType/lms/img/icon/ico_menu_show_arrow_white.svg",
	"./icon/ico_plus_white.svg": "./src/assets/roomType/lms/img/icon/ico_plus_white.svg",
	"./icon/ico_x.svg": "./src/assets/roomType/lms/img/icon/ico_x.svg",
	"./icon/ico_x_white.svg": "./src/assets/roomType/lms/img/icon/ico_x_white.svg",
	"./icon_mic_off.svg": "./src/assets/roomType/lms/img/icon_mic_off.svg",
	"./icon_mic_on.svg": "./src/assets/roomType/lms/img/icon_mic_on.svg",
	"./icon_music.svg": "./src/assets/roomType/lms/img/icon_music.svg",
	"./icon_person.svg": "./src/assets/roomType/lms/img/icon_person.svg",
	"./icon_video_off.svg": "./src/assets/roomType/lms/img/icon_video_off.svg",
	"./icon_video_on.svg": "./src/assets/roomType/lms/img/icon_video_on.svg",
	"./img_progress.svg": "./src/assets/roomType/lms/img/img_progress.svg",
	"./img_progress1.svg": "./src/assets/roomType/lms/img/img_progress1.svg",
	"./img_progress2.svg": "./src/assets/roomType/lms/img/img_progress2.svg",
	"./img_progress3.svg": "./src/assets/roomType/lms/img/img_progress3.svg",
	"./l-img/clone_mode_11_22_01_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_01_off.svg",
	"./l-img/clone_mode_11_22_01_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_01_on.svg",
	"./l-img/clone_mode_11_22_02_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_02_off.svg",
	"./l-img/clone_mode_11_22_02_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_02_on.svg",
	"./l-img/clone_mode_11_22_04_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_04_off.svg",
	"./l-img/clone_mode_11_22_04_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_04_on.svg",
	"./l-img/clone_mode_11_22_05_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_05_off.svg",
	"./l-img/clone_mode_11_22_05_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_05_on.svg",
	"./l-img/clone_mode_11_22_06_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_06_off.svg",
	"./l-img/clone_mode_11_22_06_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_06_on.svg",
	"./l-img/clone_mode_11_22_08_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_08_off.svg",
	"./l-img/clone_mode_11_22_08_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_11_22_08_on.svg",
	"./l-img/clone_mode_empty_11_22_01_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_empty_11_22_01_off.svg",
	"./l-img/clone_mode_empty_11_22_01_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_empty_11_22_01_on.svg",
	"./l-img/clone_mode_le_11_22_02_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_le_11_22_02_off.svg",
	"./l-img/clone_mode_le_11_22_02_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_le_11_22_02_on.svg",
	"./l-img/clone_mode_le_11_22_05_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_le_11_22_05_off.svg",
	"./l-img/clone_mode_le_11_22_05_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_le_11_22_05_on.svg",
	"./l-img/clone_mode_le_11_22_07_off.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_le_11_22_07_off.svg",
	"./l-img/clone_mode_le_11_22_07_on.svg": "./src/assets/roomType/lms/img/l-img/clone_mode_le_11_22_07_on.svg",
	"./laser-pointer_off.svg": "./src/assets/roomType/lms/img/laser-pointer_off.svg",
	"./laser-pointer_on.svg": "./src/assets/roomType/lms/img/laser-pointer_on.svg",
	"./logo_loading.svg": "./src/assets/roomType/lms/img/logo_loading.svg",
	"./logo_loading_white.svg": "./src/assets/roomType/lms/img/logo_loading_white.svg",
	"./menu-img/ico_menu_share_note.svg": "./src/assets/roomType/lms/img/menu-img/ico_menu_share_note.svg",
	"./menu-img/media_white.svg": "./src/assets/roomType/lms/img/menu-img/media_white.svg",
	"./menu-img/note_white.svg": "./src/assets/roomType/lms/img/menu-img/note_white.svg",
	"./mic_error.svg": "./src/assets/roomType/lms/img/mic_error.svg",
	"./mic_none.svg": "./src/assets/roomType/lms/img/mic_none.svg",
	"./mic_off.svg": "./src/assets/roomType/lms/img/mic_off.svg",
	"./mic_on.svg": "./src/assets/roomType/lms/img/mic_on.svg",
	"./mic_on_white.svg": "./src/assets/roomType/lms/img/mic_on_white.svg",
	"./neon-pen_off.svg": "./src/assets/roomType/lms/img/neon-pen_off.svg",
	"./neon-pen_on.svg": "./src/assets/roomType/lms/img/neon-pen_on.svg",
	"./out_white.svg": "./src/assets/roomType/lms/img/out_white.svg",
	"./pen_off.svg": "./src/assets/roomType/lms/img/pen_off.svg",
	"./pen_on.svg": "./src/assets/roomType/lms/img/pen_on.svg",
	"./popup_close.svg": "./src/assets/roomType/lms/img/popup_close.svg",
	"./q-pin_off.svg": "./src/assets/roomType/lms/img/q-pin_off.svg",
	"./q-pin_on.svg": "./src/assets/roomType/lms/img/q-pin_on.svg",
	"./refresh_white.svg": "./src/assets/roomType/lms/img/refresh_white.svg",
	"./screen_none.svg": "./src/assets/roomType/lms/img/screen_none.svg",
	"./screen_on.svg": "./src/assets/roomType/lms/img/screen_on.svg",
	"./select_arrow.svg": "./src/assets/roomType/lms/img/select_arrow.svg",
	"./select_on.svg": "./src/assets/roomType/lms/img/select_on.svg",
	"./sound-effect-img/music_selected.svg": "./src/assets/roomType/lms/img/sound-effect-img/music_selected.svg",
	"./speaker_media_off_white.svg": "./src/assets/roomType/lms/img/speaker_media_off_white.svg",
	"./speaker_media_on_white.svg": "./src/assets/roomType/lms/img/speaker_media_on_white.svg",
	"./speaker_on.svg": "./src/assets/roomType/lms/img/speaker_on.svg",
	"./speaker_on_white.svg": "./src/assets/roomType/lms/img/speaker_on_white.svg",
	"./stroke-width_off.svg": "./src/assets/roomType/lms/img/stroke-width_off.svg",
	"./stroke-width_on.svg": "./src/assets/roomType/lms/img/stroke-width_on.svg",
	"./teacher_group.svg": "./src/assets/roomType/lms/img/teacher_group.svg",
	"./test_user.svg": "./src/assets/roomType/lms/img/test_user.svg",
	"./text_off.svg": "./src/assets/roomType/lms/img/text_off.svg",
	"./text_on.svg": "./src/assets/roomType/lms/img/text_on.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/roomType/lms/img sync recursive ^\\.\\/.*_.*\\.svg$";